import repos from "@/data/projects-meta.json";
import { hardcoded } from "@/context/locale";

const hasDocs = (p) => p.hasReadme === true;

export const DOC_GROUPS = [
  { id: "phare", labelKey: "portfolio.categories.phare", projects: (repos.phare ?? []).filter(hasDocs) },
  { id: "core", labelKey: "portfolio.categories.core", projects: repos.core.filter(hasDocs) },
  { id: "edu", labelKey: "portfolio.categories.edu", projects: repos.edu.filter(hasDocs) },
  { id: "legacy", labelKey: "portfolio.categories.legacy", projects: repos.legacy.filter(hasDocs) },
  { id: "vestigia", label: hardcoded("Vestigia"), projects: (repos.vestigia ?? []).filter(hasDocs) },
];

export const ALL_DOCS = DOC_GROUPS.flatMap((g) => g.projects);

export const findDoc = (slug) => ALL_DOCS.find((p) => p.slug === slug) ?? null;

export const localDesc = (p, locale) => p[`desc_${locale}`] || p.desc;
